import restUrls from "web/constants/restUrls";

import { ISubscriptionUserCurrent } from "web/types/Subscription";
import { HydraResponse } from "web/types/Utils";

import { AppDispatch } from "web/store";

import api from "../api/apiSlice";

export const subscriptionsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUserSubscription: builder.query<ISubscriptionUserCurrent[], void>(
      {
        query: () => ({
          url: restUrls.currentUserSubscription,
          headers: {
            "Content-Type": "application/ld+json",
            Accept: "application/ld+json",
          },
        }),
        transformResponse: (
          result: HydraResponse<ISubscriptionUserCurrent>
        ) => {
          return result["hydra:member"] || [];
        },
        providesTags: ["CurrentUserSubscriptions"],
      }
    ),
  }),
});

export const invalidateCurrentUserSubscription = (dispatch: AppDispatch) =>
  dispatch(
    subscriptionsApiSlice.util.invalidateTags(["CurrentUserSubscriptions"])
  );

export const { useGetCurrentUserSubscriptionQuery } = subscriptionsApiSlice;
